<template>
<v-app>
<v-main
    v-if="organization_account != null"
>

   <m-make-payment-app-bar
        :value="organization_label"
        :banner_branding="banner_branding"
    />

    <v-container>
        <div
            style="margin-left: 15px; margin-right: 15px"
        >

        <div
            style="text-align: center; margin-top: 30px; font-size: 32px"
            v-if="show_thank_you"
        >   
            Thanks!<br/><br/>We will be in touch soon.
        </div>

        <div
            v-else
        >

            <p
                style="margin-top: 30px; margin-bottom: 30px"
            >
                Enter your information to receive text messages with information, promotions and offers from {{organization_account.label}}
            </p>

            <v-text-field
                label="First name"
                v-model="first_name"
            />

            <v-text-field
                label="Last name"
                v-model="last_name"
            />

            <v-text-field
                label="Phone Number"
                v-model="phone_number"
                type="tel"
                v-on:input="onChangeMobile"
            />

            <div
                v-if="robust_age_gate"
            >
                <p>You must be 21 or older to receive our text messages.  Please enter your birthday in MM/DD/YYYY format so we can verify your age</p>

                <v-text-field
                    label="Birthday"
                    v-model="birthday"
                    hint="MM/DD/YYYY -- use a leading zero (e.g. 01 for January). slashes will be added automatically"
                    persistent-hint
                    v-on:input="onInputBirthday"
                    type="tel"
                />
            </div>

            <m-legal-checkbox-agreement
                    :organization_id="organization_id"
                    type="default-opt-in-form-agreement"
                    v-model="agreement_cb"
                    ref="agreement"
                />

            <v-alert
                v-model="show_alert"
                color="primary"
                type="error"
                dismissible
                style="margin-top: 15px"
            >
                {{alert_text}}
            </v-alert>
            
            <div
                style="text-align: right; padding-top: 30px"
            >
                <v-btn
                    color="secondary"
                    :disabled="!is_valid"
                    v-on:click="onClickSubmit"
                >
                    Submit
                </v-btn>
            </div>
        </div>

        </div>
    </v-container>

</v-main>


  <m-global-spinner/>
  <m-global-snackbar/>
  <m-global-alert/>
  <m-global-confirm/>
  <m-global-prompt/>

</v-app>
</template>

<script>

export default {

    data() {
        return {
            banner_branding: null,
            organization_account: null,
            agreement_cb: false,

            first_name: null,
            last_name: null,
            phone_number: null,
            birthday: null,

            show_alert: false,
            alert_text: null,

            show_thank_you: false,
        }
    },

    mounted () {
        this.loadProfile();
    },   

    methods: {
      loadProfile()
      {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/opt-in-form/default/profile',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                        'banner_id': this.$route.params.banner_id,
                    },
            
                'on_success': (data) => {
                        this.banner_branding = data.banner_branding;
                        this.organization_account = data.organization_account;
                    },
            
                'on_error': 'Unable to get form information',
            });
      },

      onClickSubmit()
      {
            if ( !this.is_valid )
            {
                // Should not be possible...
                this.alert_text = 'Please fill out all of the above fields.';
                this.show_alert = true;
                return;
            }

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/opt-in-form/default/opt-in',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                        'first_name': this.first_name,
                        'last_name': this.last_name,
                        'phone_number': this.phone_number,
                        'birthday': this.birthday,
                        'agreement_specimen': this.$refs['agreement'].getSpecimen(),
                        'submitted_from_url': ''+document.location,
                    },
            
                'on_success': (data) => {

                        if ( data.valid == false )
                        {
                            this.alert_text = data.message;
                            this.show_alert = true;
                            return;
                        }

                        this.show_thank_you = true;

                    },
            
                'on_error': 'Unable to opt in',
            });
      },

      isBlank(value)
      {
        if ( value == null ) return true;
        if ( value.trim().length == 0 ) return true;
        return false;
      },

      onInputBirthday()
      {
        this.birthday = this.$rc.maskMMDDYYYY(this.birthday);
      },

      onChangeMobile(event)
      {
        this.phone_number = this.$rc.maskPhoneNumber(this.phone_number);
      },
    },

    computed: {
        robust_age_gate() {
            if ( this.organization_account == null ) 
                return false;
            
            return this.organization_account.industry == 'wine';
        },

        is_valid()
        {
            if ( this.agreement_cb == false ) return false;

            if ( this.isBlank(this.first_name) ) return false;
            if ( this.isBlank(this.last_name) ) return false;
            if ( this.isBlank(this.phone_number) ) return false;
            if ( this.isBlank(this.birthday) && this.robust_age_gate ) return false;

            return true;
        },

        organization_label()
        {
            if ( this.organization_account == null ) return '';
            return this.organization_account.label;
        },

        organization_id()
        {
            if ( this.organization_account == null ) return '';
            return this.organization_account.organization_id;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>